/* eslint-disable max-len */

export default {
  blocks: [
    {
      key: '9vnrn',
      text: ' ',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
  entityMap: {
    '0': {
      data: {
        config: {
          alignment: 'center',
          key: 'ahltd',
          showDescription: true,
          showTitle: true,
          size: 'content',
          textWrap: 'wrap',
        },
        src: {
          file_name: '7f96510c9da54d598aa90350b9f5958c.jpg',
          height: 1200,
          id: '7f96510c9da54d598aa90350b9f5958c.jpg',
          original_file_name: '7f96510c9da54d598aa90350b9f5958c.jpg',
          width: 1600,
        },
      },
      mutability: 'IMMUTABLE',
      type: 'wix-draft-plugin-image',
    },
    '1': {
      data: {
        config: {
          alignment: 'center',
          key: 'cbi6h',
          layout: 'small',
          size: 'content',
          spacing: 0,
          textWrap: 'wrap',
        },
        items: [
          {
            itemId: 'd70f8f24435d48b9be40de85ed60dee1.jpg',
            metadata: { height: 2648, processedByConsumer: true, width: 3200 },
            url: 'd70f8f24435d48b9be40de85ed60dee1.jpg',
          },
        ],
        styles: {
          allowDownload: false,
          allowHover: false,
          allowSocial: false,
          cubeRatio: 1,
          cubeType: 'fill',
          enableInfiniteScroll: true,
          galleryLayout: 2,
          gallerySizePx: 300,
          gallerySizeType: 'px',
          galleryThumbnailsAlignment: 'bottom',
          gridStyle: 1,
          imageMargin: 20,
          isVertical: false,
          itemClick: 'link',
          loveButton: false,
          numberOfImagesPerRow: 3,
          oneRow: false,
          showArrows: false,
          thumbnailSpacings: 0,
          titlePlacement: 'SHOW_ON_HOVER',
        },
      },
      mutability: 'IMMUTABLE',
      type: 'wix-draft-plugin-gallery',
    },
  },
  VERSION: '7.6.1',
};
